import { useLocalReactionStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import { ReactViewProps } from "csi/middleware/common";
import React from "react";
import { usePresentationPageStore } from "./main";
import PPProductLayout from "./PPProductLayout";

export const PPProducts = (props: ReactViewProps) => {
	const pageStore = usePresentationPageStore();
	const loc = useLocale();
	const productStore = useLocalReactionStore(() => pageStore.createProductLayoutStore(loc));

	return (
		<>
			{productStore &&
				<PPProductLayout inTab productStore={productStore} />
			}
		</>
	);
};

export default PPProducts;